import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AmountFormatPipe, StaticMsgModule } from '@lib/pipes';
import { PaymentDetailComponent } from './payment-detail.component';
import { PaymentDetailS02P020Module } from './sup-components/payment-detail-s02-p020/payment-detail-s02-p020.module';
import { PaymentDetailS01P031Module } from './sup-components/payment-detail-s01-p031/payment-detail-s01-p031.module';

@NgModule({
  declarations: [PaymentDetailComponent],
  exports: [PaymentDetailComponent],
  imports: [CommonModule, StaticMsgModule, PaymentDetailS02P020Module, PaymentDetailS01P031Module],
  providers: [AmountFormatPipe],
})
export class PaymentDetailModule {}
